/*
 * @Author: shiguang
 * @Date: 2023-04-25 10:46:45
 * @LastEditors: yusha
 * @LastEditTime: 2024-06-06 15:03:08
 * @Description: shiguang
 */
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/i18n';
import './index.scss';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(<App />);
